const colors = {
  // Light Mode Colors
  primary: '#007BFF',
  secondary: '#0056b3',
  background: '#F8F9FA',
  surface: '#FFFFFF',
  textPrimary: '#212529',
  textSecondary: '#6C757D',
  accent: '#FF4081', // Example accent color (can be changed)

  // Dark Mode Colors
  primaryDark: '#339AFF',
  secondaryDark: '#1A73E8',
  backgroundDark: '#121212',
  surfaceDark: '#1E1E1E',
  textPrimaryDark: '#EAEAEA',
  textSecondaryDark: '#A0A0A0',
  accentDark: '#FF4081', // Same or different accent for dark mode
};

export default colors;
